export class UserCredentials {
  username: string;
  password: string;
  isPatent:boolean=false;
  isCuit:boolean=false;
  isUser:boolean=true;
  authorities: any[];
  bankId: string;
 constructor(user:UserCredentials){
     if (user !== null){
         this.username = user.username;
         this.password = user.password;
         this.authorities = user.authorities;
         this.isCuit = user.isCuit;
         this.isPatent = user.isPatent;
         this.isUser = user.isUser;
         this.bankId = user.bankId;
     }
 }
    
  public getRol():string{
      return this.authorities[0].authority;
  }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/userCredentials.ts
 **/